import { jsx as _jsx } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { Rectangle as VisRectangle } from '@vis.gl/react-google-maps';
import { useReportBounds } from "../lib/BoundsRegistry";
export const Rectangle = ({ bounds, editable, draggable, strokeColor, strokeOpacity, strokeWeight, fillColor, fillOpacity, onBoundsChanged, onClick }) => {
    useReportBounds(useMemo(() => [
        { lat: bounds.north, lng: bounds.east },
        { lat: bounds.south, lng: bounds.west }
    ], [bounds.north, bounds.east, bounds.south, bounds.west]));
    return (_jsx(VisRectangle, { bounds: { north: bounds.north, east: bounds.east, south: bounds.south, west: bounds.west }, editable: editable ?? true, draggable: draggable ?? true, strokeColor: strokeColor ?? '#000000', strokeOpacity: strokeOpacity ?? 0.8, strokeWeight: strokeWeight ?? 4, fillColor: fillColor ?? '#000000', fillOpacity: fillOpacity ?? 0.3, onClick: () => onClick?.(), onBoundsChanged: rectBounds => {
            if (!rectBounds || !onBoundsChanged) {
                return;
            }
            const ne = rectBounds.getNorthEast();
            const sw = rectBounds.getSouthWest();
            const center = rectBounds.getCenter();
            onBoundsChanged({ lat: center.lat(), lng: center.lng() }, { north: ne.lat(), east: ne.lng(), south: sw.lat(), west: sw.lng() });
        } }));
};
